import isDowngrading from "../utils/isDowngrading";
import FormatCurrency from "../../Homepage/components/FormatCurrency";
import convertSecondsToDaysToDays from "../utils/convertSecondsToDays";
import React from "react";
import withTranslations from "../../../../../../hocs/withTranslations";
import withUserData from "../../../../../../hocs/withUserData";
import { compose } from "redux";
import getIsFree from "../utils/getIsFree";
import { getPaymentMethodPricing } from "../utils/useOnPaymentButtonClick";
import hasSubscription from "../utils/hasSubscription";

const SelectedPlanDescription = ({
  currentCurrencyOfferByPeriod,
  userData,
  isSelectedPackageSubscription,
  translate,
  locale,
  paymentDetails,
  selectedPaymentMethod,
  selectedPlan
}) => {
  const isFree = getIsFree({ currentCurrencyOfferByPeriod });
  const paymentMethodPricing = getPaymentMethodPricing({
    selectedPaymentMethod,
    currentCurrencyOfferByPeriod
  });

  return currentCurrencyOfferByPeriod && !isFree ? (
    userData ? (
      <span
        className={"block text-xs text-black opacity-70"}
        dangerouslySetInnerHTML={{
          __html: isSelectedPackageSubscription
            ? isDowngrading({
                userCurrentPlan: userData?.current_plan,
                selectedPlan
              })
              ? translate(
                  `plans_payment-bar_downgrading_current-plan_subscription %{offerAmount} %{orderAmount} %{days} %{newPlanName} %{userCurrentPlanName} %{userCurrentDays}`,
                  {
                    offerAmount: FormatCurrency({
                      locale: locale,
                      value: paymentMethodPricing?.offer_amount ?? 0
                    }),
                    orderAmount: FormatCurrency({
                      locale: locale,
                      value: paymentMethodPricing?.order_amount ?? 0
                    }),
                    days: currentCurrencyOfferByPeriod.days,
                    newPlanName: selectedPlan?.name,
                    userCurrentPlanName: userData?.current_plan?.name,
                    userCurrentDays: convertSecondsToDaysToDays(
                      paymentDetails?.end_date_in_seconds
                    )
                  }
                )
              : translate(
                  `plans_payment-bar_current-plan_subscription %{orderAmount} %{offerAmount} %{days}`,
                  {
                    orderAmount: FormatCurrency({
                      locale: locale,
                      value: paymentMethodPricing?.order_amount ?? 0
                    }),
                    offerAmount: FormatCurrency({
                      locale: locale,
                      value: paymentMethodPricing?.offer_amount ?? 0
                    }),
                    days: currentCurrencyOfferByPeriod.days
                  }
                )
            : translate(
                `plans_payment-bar_current-plan_non_subscription %{orderAmount} %{offerAmount} %{days}`,
                {
                  orderAmount: FormatCurrency({
                    locale: locale,
                    value: paymentMethodPricing?.order_amount ?? 0
                  }),
                  offerAmount: FormatCurrency({
                    locale: locale,
                    value: paymentMethodPricing?.offer_amount ?? 0
                  }),
                  days: currentCurrencyOfferByPeriod.days
                }
              )
        }}
      />
    ) : null
  ) : (
    <span
      className={"text-xs text-black opacity-70 text-left"}
      dangerouslySetInnerHTML={{
        __html: isDowngrading({
          userCurrentPlan: userData?.current_plan,
          selectedPlan
        })
          ? hasSubscription({ paymentDetails })
            ? translate(
                `plans_payment-bar_subscription_downgrade-to-free %{userCurrentPlanName} %{newPlanName} %{days}`,
                {
                  userCurrentPlanName: userData?.current_plan?.name,
                  newPlanName: selectedPlan?.name,
                  days: convertSecondsToDaysToDays(
                    paymentDetails?.end_date_in_seconds
                  )
                }
              )
            : translate(
                "plans_payment-bar_no-subscription_downgrade-to-free %{userCurrentPlanName} %{newPlanName} %{days}",
                {
                  userCurrentPlanName: userData?.current_plan?.name,
                  newPlanName: selectedPlan?.name,
                  days: convertSecondsToDaysToDays(
                    paymentDetails?.end_date_in_seconds
                  )
                }
              )
          : translate("plans_payment-bar_free")
      }}
    ></span>
  );
};

export default compose(withTranslations, withUserData)(SelectedPlanDescription);
